import React, { useEffect } from 'react';
import CompetitorTable from './table';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { connect, useDispatch, useHistory, useIntl } from 'umi';
import { excludeChannels } from '@/pages/opinion/constants';
import './index.scss';
import { mergeExcludeChannel } from '@op/components/FilterCommon/utils';
function Competitor(props: any) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const history = useHistory();

  const {
    userInfo,
    gameInfo,
    filter,
    overviewCompetitorLoading = true,
    overviewCompetitor,
    dialogVisible,
    showAigcCard,
  } = props;

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;
    dispatch({
      type: 'opinionPerformance/getOverviewCompetitor',
      payload: mergeExcludeChannel(
        {
          ...filter,
          ...gameInfo,
          user_id: userInfo.userid,
          sort_item: gameInfo.entity_type === 'mobile' ? 'dau' : 'mentions',
          sort_model: 'desc',
          statistics_field: 'competitor',
        },
        excludeChannels,
      ),
    });
  }, [userInfo, filter]);

  const isEmpty =
    !Array.isArray(overviewCompetitor?.list) ||
    overviewCompetitor.list.length === 0;

  return (
    <CardCommon
      title={formatMessage({ id: 'Compare Competitors' })}
      className="dbo-competitor-card"
      hasTitleArrow
      handleTitleOnClick={() => history.push('/opinion/Competitor')}
      loading={overviewCompetitorLoading}
      loadingHeight={295}
      hasEmptyImg={false}
      emptyHeight={showAigcCard ? 168 : 295}
      empty={isEmpty}
    >
      <CompetitorTable
        data={overviewCompetitor?.list || []}
        gameInfo={gameInfo}
        dialogVisible={dialogVisible}
        showAigcCard={showAigcCard}
      ></CompetitorTable>
    </CardCommon>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionFilter, opinionPerformance } =
    state;

  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    overviewCompetitorLoading:
      loading.effects['opinionPerformance/getOverviewCompetitor'],
    overviewCompetitor: opinionPerformance.competitor,
  };
})(Competitor);
